import { Category, Product } from "@/@types";

/** Grupos de filtro oferecidos pela API, na ordem do painel. */
export const FACET_KEYS = ["kosher_tipo", "cor", "material", "especificacao", "produto"] as const;

export type FacetKey = (typeof FACET_KEYS)[number];

export interface FacetOption {
  /** Valor cru do ERP, usado na querystring. */
  value: string;
  /** Rótulo pronto para exibição. */
  label: string;
  slug: string;
  /**
   * Quantos produtos restam com esta opção, já considerando os filtros dos
   * outros grupos. Zero significa que a opção deve aparecer desabilitada.
   */
  count: number;
  /** Quantos produtos existem no recorte base, ignorando os filtros. */
  total: number;
}

export type Facets = Record<FacetKey, FacetOption[]>;

export type ActiveFilters = Record<FacetKey, string[]>;

/** Formato antigo: apenas os valores, sem contagem. Sai quando o legado morrer. */
export interface LegacyFilters {
  cores?: string[] | null;
  materiais?: string[] | null;
  especificacoes?: string[] | null;
  produtos?: string[] | null;
  marcas?: string[] | null;
}

export interface ProductsResponse {
  products: Product[];
  total: number;
  category: (Category & { category_images?: CategoryImage[] }) | null;
  offset: number;
  limit: number;
  filters: LegacyFilters;
  facets: Facets;
  applied_filters: ActiveFilters;
}

/** /api/search devolve, além da listagem, os semelhantes e os termos usados. */
export interface SearchResponse extends ProductsResponse {
  /** A API só ranqueia os 250 melhores candidatos; true = `total` é um piso. */
  total_capped?: boolean;
  semantic_products?: Product[];
  semantic_total?: number;
  matched_terms?: string[];
  dropped_terms?: string[];
}

export interface CategoryImage {
  id: string;
  image: { url: string };
}

export const EMPTY_FACETS: Facets = {
  kosher_tipo: [],
  cor: [],
  material: [],
  especificacao: [],
  produto: [],
};

export const EMPTY_ACTIVE_FILTERS: ActiveFilters = {
  kosher_tipo: [],
  cor: [],
  material: [],
  especificacao: [],
  produto: [],
};

/** Título exibido no painel para cada grupo. */
export const FACET_LABELS: Record<FacetKey, string> = {
  kosher_tipo: "Kosher",
  cor: "Cores",
  material: "Materiais",
  especificacao: "Especificação",
  produto: "Produto",
};
